import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import logo from '../../static/img/logo-icon.png';

const { Text } = Typography;

const Spinner = ({ size = 50, ringSize = 120, dotCount = 12, speed = 120, text }) => {
    const containerStyle = {
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    };

    const spinnerWrapperStyle = {
        position: 'relative',
        width: ringSize,
        height: ringSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        marginBlock: '20px',
    };

    const logoStyle = {
        width: size,
        height: 'auto',
        zIndex: 2,
        position: 'absolute',
        top: '57%',
        left: '57%',
        transform: 'translate(-57%, -57%)',
    };

    const radius = ringSize / 2 - 5;
    const [filledDots, setFilledDots] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setFilledDots(prev => (prev + 1) % (dotCount + 1));
        }, speed);
        return () => clearInterval(interval);
    }, [dotCount, speed]);

    const dots = [];
    for (let i = 0; i < dotCount; i++) {
        const angle = (i * 360) / dotCount;
        const dotStyle = {
            position: 'absolute',
            width: 8,
            height: 8,
            borderRadius: '50%',
            top: '50%',
            left: '50%',
            transform: `rotate(${angle}deg) translate(${radius}px) rotate(-${angle}deg)`,
            transformOrigin: 'center center',
            backgroundColor: i < filledDots ? '#1890ff' : 'rgba(0,0,0,0.1)',
            transition: 'background-color 0.2s',
        };
        dots.push(<div key={i} style={dotStyle}></div>);
    }

    return (
        <div style={containerStyle}>
            <div style={spinnerWrapperStyle}>
                {dots}
                <img src={logo} alt="logo" style={logoStyle} />
            </div>
            {text && <Text strong>{text}</Text>}
        </div>
    );
};

export default Spinner;
